import React, { Fragment, useState, useEffect } from 'react';
import { Button, ButtonToolbar, CardBody, Label, Collapse } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { IconButton } from 'material-ui';
import { Card } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from 'prop-types';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import { twoDecimalPlaces } from '../../../shared/components/form/Masks';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';
import renderField from '../../../shared/components/form/RenderField';
import textAreaField from '../../../shared/components/form/TextAreaField';
import Select from '../../../shared/components/form/Select';
import SmartIcon from './SmartIcon';
import validate from './Validate';
import GraphQL from '../../../GraphQL';
import {
  INDIVIDUAL,
  MULTIPLE,
  SEND_TIMELINE,
  HOUR_TYPE,
} from '../../../shared/utils/constants';
import { listIcons, mealTypes } from '../../../shared/queries/ItemsTablet';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import SelectVirtualized from '../../../shared/components/form/SelectVirtualized';

const SideBar = (props) => {
  const { t, initialize, dispatch, change, handleSubmit, toggle, dto, isOpen } =
    props;

  const [requestTimeTypeCollapse, setRequestTimeTypeCollapse] = useState(false);
  const [mealTypeCollapse, setMealtypeCollapse] = useState(false);
  const [selectMealtypes, setSelectMealTypes] = useState([]);
  const [iconTimeline, setIconTimeline] = useState({});
  const [requireDescription, setRequireDescription] = useState(true);
  const [listAllIcons, setListAllIcons] = useState([]);
  const selectType = [
    { value: INDIVIDUAL, label: t('mnt_tablet-items.label.INDI') },
    { value: MULTIPLE, label: t('mnt_tablet-items.label.MULP') },
  ];
  const selectSendTimeline = [
    { value: SEND_TIMELINE.NO, label: t('mnt_tablet-items.label.N') },
    { value: SEND_TIMELINE.YES, label: t('mnt_tablet-items.label.S') },
  ];
  const selectRequestTimeType = [
    { value: HOUR_TYPE.EXACT_HOUR, label: t('mnt_tablet-items.label.INI') },
    {
      value: HOUR_TYPE.START_END_HOUR,
      label: t('mnt_tablet-items.label.INIFIN'),
    },
  ];

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const iconTimelineChangeHandler = (value) => {
    change('iconTimeline', value);
  };

  const iconTabletChangeHandler = (value) => {
    change('iconTablet', value);

    if (
      Object.keys(dto.iconTimeline).length === 0 &&
      Object.keys(iconTimeline).length === 0
    ) {
      setIconTimeline(value);
      iconTimelineChangeHandler(value);
    }
  };

  const onChangeTitleTimeline = (value) => {
    if (value.length <= 25) {
      change('titleTimeline', value);
    }
  };

  const loadListIcons = () => {
    const query = listIcons();
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        res.listIcons = res.listIcons.map((item) => ({
          ...item,
        }));
        setListAllIcons(res.listIcons);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadMealTypes = () => {
    const query = mealTypes();
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        res.mealTypes = res.mealTypes.map((item) => ({
          ...item,
          value: item,
          label: t(`${item.name}`),
        }));
        setSelectMealTypes(res.mealTypes);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };
  const checked = ({ foodItem, requestTime, sendTimeline }) => {
    if (foodItem) {
      setMealtypeCollapse(true);
    } else {
      setMealtypeCollapse(false);
    }
    if (requestTime) {
      setRequestTimeTypeCollapse(true);
    } else {
      setRequestTimeTypeCollapse(false);
    }
    if (sendTimeline && sendTimeline.value !== SEND_TIMELINE.NO) {
      setRequireDescription(true);
    } else {
      setRequireDescription(false);
    }
  };

  const requireDescriptionChange = (value) => {
    if (value !== SEND_TIMELINE.NO) {
      setRequireDescription(true);
    } else {
      setRequireDescription(false);
    }
  };

  useEffect(() => {
    initialize(dto);
    checked(dto);
    setIconTimeline(dto.iconTimeline);
  }, [dto]);

  useEffect(() => {
    loadListIcons();
    loadMealTypes();
  }, []);

  return (
    <Fragment>
      <Card className={isOpen ? 'items-sidebar-open' : 'items-sidebar-close'}>
        <IconButton className="card-icon-button" onClick={toggle}>
          <CloseIcon />
        </IconButton>
        <CardBody>
          <form className="form" onSubmit={handleSubmit}>
            <div className="form__form-group">
              <span className="form__form-group-label modal-span-flex">
                {t('mnt_tablet-items.name')}
              </span>
              <div className="form_form-group-field">
                <Field
                  name="name"
                  type="text"
                  component={renderField}
                  maxLength="50"
                  onChange={(event) =>
                    onChangeTitleTimeline(event.target.value)
                  }
                  placeholder={t('mnt_tablet-items.placeholders.name')}
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label modal-span-flex">
                {t('mnt_tablet-items.short-name')}
              </span>
              <div className="form_form-group-field">
                <Field
                  name="shortName"
                  type="text"
                  component={renderField}
                  maxLength="25"
                  placeholder={t('mnt_tablet-items.placeholders.name-ab')}
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label modal-span-flex">
                {t('mnt_tablet-items.diary-title')}
              </span>
              <div className="form_form-group-field">
                <Field
                  name="titleTimeline"
                  type="text"
                  component={renderField}
                  maxLength="25"
                  onChange={(event) =>
                    onChangeTitleTimeline(event.target.value)
                  }
                  placeholder={t('mnt_tablet-items.placeholders.title')}
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label modal-span-flex">
                {t('mnt_tablet-items.item-value')}
              </span>
              <div className="form__form-group-field">
                <Field
                  name="itemValue"
                  type="text"
                  component={renderField}
                  {...twoDecimalPlaces()}
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label modal-span-flex">
                {t('mnt_tablet-items.item-order')}
              </span>
              <div className="form__form-group-field">
                <Field
                  name="order"
                  type="number"
                  component={renderField}
                  min="0"
                  max="99"
                  placeholder={t('mnt_tablet-items.placeholders.order')}
                />
              </div>
            </div>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Label className="generic__label">
                  {t('mnt_tablet-items.active')}
                </Label>
                <Field
                  name="active"
                  component={renderCheckBoxField}
                  className="colored-click"
                />
              </div>
            </div>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Label className="generic__label">
                  {t('mnt_tablet-items.request-complement')}
                </Label>
                <Field
                  name="addOn"
                  component={renderCheckBoxField}
                  className="colored-click"
                />
              </div>
            </div>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Label className="generic__label">
                  {t('mnt_tablet-items.request-appointment-time')}
                </Label>
                <Field
                  name="requestTime"
                  component={renderCheckBoxField}
                  className="colored-click"
                  onChange={(event) => {
                    if (event.target) {
                      setRequestTimeTypeCollapse(event.target.checked);
                    }
                  }}
                />
              </div>
            </div>
            <Collapse isOpen={requestTimeTypeCollapse} className="w-100">
              <div className="form__form-group">
                <span className="form__form-group-label modal-span-flex">
                  {t('mnt_tablet-items.request-time-type')}
                </span>
                <div className="form_form-group-field">
                  <Field
                    name="requestTimeType"
                    type="text"
                    component={Select}
                    options={selectRequestTimeType}
                  />
                </div>
              </div>
            </Collapse>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Label className="generic__label">
                  {t('mnt_tablet-items.food')}
                </Label>
                <Field
                  name="foodItem"
                  component={renderCheckBoxField}
                  className="colored-click"
                  onChange={(event) => {
                    if (event.target) {
                      setMealtypeCollapse(event.target.checked);
                    }
                  }}
                />
              </div>
            </div>
            <Collapse isOpen={mealTypeCollapse} className="w-100">
              <div className="form__form-group">
                <span className="form__form-group-label ">
                  {t('mnt_tablet-items.meal-type')}
                </span>
                <div className="form_form-group-field">
                  <Field
                    name="typeOfMeal"
                    type="text"
                    component={Select}
                    options={selectMealtypes}
                  />
                </div>
              </div>
            </Collapse>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Label className="generic__label">
                  {t('mnt_tablet-items.calc-period')}
                </Label>
                <Field
                  name="calculatePeriod"
                  component={renderCheckBoxField}
                  className="colored-click"
                />
              </div>
            </div>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Label className="generic__label">
                  {t('mnt_tablet-items.item-form')}
                </Label>
                <Field
                  name="formItem"
                  component={renderCheckBoxField}
                  className="colored-click"
                />
              </div>
            </div>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Label className="generic__label">
                  {t('mnt_tablet-items.not-conforming')}
                </Label>
                <Field
                  name="notConform"
                  component={renderCheckBoxField}
                  className="colored-click"
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label modal-span-flex">
                {t('mnt_tablet-items.diary-auto-generated')}
              </span>
              <div className="form_form-group-field">
                <Field
                  name="sendTimeline"
                  type="text"
                  component={SelectVirtualized}
                  options={selectSendTimeline}
                  onChange={({ value }) => requireDescriptionChange(value)}
                />
              </div>
            </div>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Label className="generic__label">
                  {t('mnt_tablet-items.display-hour-diary')}
                </Label>
                <Field
                  name="timelineTime"
                  component={renderCheckBoxField}
                  className="colored-click"
                />
              </div>
            </div>
            <Collapse isOpen={requireDescription} className="w-100">
              <div className="form__form-group">
                <span className="form__form-group-label modal-span-flex">
                  {t('mnt_tablet-items.text-to-diary')}
                </span>
                <div className="form__form-group-field">
                  <Field
                    name="description"
                    type="text"
                    component={textAreaField}
                    maxLength="250"
                    placeholder={t(
                      'mnt_tablet-items.placeholders.description-timeline'
                    )}
                  />
                </div>
              </div>
            </Collapse>
            <div className="form__form-group">
              <span className="form__form-group-label modal-span-flex">
                {t('mnt_tablet-items.select-type')}
              </span>
              <div className="form_form-group-field">
                <Field
                  name="multiple"
                  type="text"
                  component={SelectVirtualized}
                  options={selectType}
                  placeholder={t('mnt_tablet-items.select-type')}
                />
              </div>
            </div>
            <span className="form__form-group-label">
              {t('mnt_tablet-items.icons')}
            </span>
            <div className="form__form-group--2_columns align-content-center d-flex">
              <div className="form__form-group">
                <span className="form__form-group--centered">
                  {t('mnt_tablet-items.tablet')}
                </span>
                <div className="form__form-group--centered">
                  <Field
                    name="iconTablet"
                    component={SmartIcon}
                    data={listAllIcons}
                    icon={dto.iconTablet}
                    iconChangeHandler={iconTabletChangeHandler}
                  />
                </div>
              </div>
              <div className="form__form-group">
                <span className="form__form-group--centered">
                  {t('mnt_tablet-items.diary-icon')}
                </span>
                <div className="form__form-group--centered">
                  <Field
                    name="iconTimeline"
                    component={SmartIcon}
                    data={listAllIcons}
                    icon={iconTimeline}
                    iconChangeHandler={iconTimelineChangeHandler}
                  />
                </div>
              </div>
            </div>
            <ButtonToolbar className="form__button-toolbar flex-nowrap flex-grow-1">
              <Button color="primary" className="btn-form" onClick={toggle}>
                {t('general.cancel')}
              </Button>
              <Button color="success" className="btn-form" type="submit">
                {t('general.save')}
              </Button>
            </ButtonToolbar>
          </form>
        </CardBody>
      </Card>
    </Fragment>
  );
};

SideBar.propTypes = {
  t: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default reduxForm({
  form: 'TabletItemsForm',
  validate,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(withTranslation('common')(SideBar));
